/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    ICreateActionContext
} from '@msdyn365-commerce/core';
import { getWebGroupsByCategoryAsync } from './DataActionExtension.g';
import { IWebGroupData } from './DataServiceEntities.g';
import { GetCategoryIdFromUrl, GetWebgroupIdFromUrl } from '../utilities';
import { GetCatalogIdFromContext } from '../utilities/get-catalog-id-from-context';

/**
 * GetWebgroupByCategory Input Action
 */
export class GetWebgroupByCategoryInput implements IActionInput {
    constructor() {}

    public getCacheKey = () => `WebgroupByCategory`;
    public getCacheObjectType = () => 'WebgroupByCategory';
    public dataCacheType = (): CacheType => 'none';
}

export const createGetWebgroupByCategoryInput = (args: ICreateActionContext): IActionInput => {
    return new GetWebgroupByCategoryInput();
};

export async function getWebgroupByCategoryAction(input: GetWebgroupByCategoryInput, ctx: IActionContext): Promise<IWebGroupData[]> {
    //const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
    let catalogId = GetCatalogIdFromContext(ctx).toString();
    if (catalogId === '-1') {
        catalogId = '0';
    }
    const categyoryId = GetCategoryIdFromUrl(ctx);
    const webgroupId = GetWebgroupIdFromUrl(ctx);
    if (!categyoryId && !webgroupId) {
        throw new Error('No category or webgroup Id provided');
    }
    return getWebGroupsByCategoryAsync({ callerContext: ctx }, categyoryId, webgroupId, catalogId)
        .then(data => {
            return data;
        })
        .catch(error => {
            ctx.telemetry.exception(error);
            ctx.trace('[get-webgroup-by-category] Unable to load webgroup results');
            throw new Error('[get-webgroup-by-category] Unable to load webgroup results');
        });
}

export default createObservableDataAction({
    action: <IAction<IWebGroupData[]>>getWebgroupByCategoryAction,
    id: 'GetWebgroupByCategory',
    input: createGetWebgroupByCategoryInput
});
